import Login from "pages/Auth/Login";
import Page404 from "pages/Page404";
import Home from "pages/Home/Home";
import Users from "pages/Users/Users";
import User from "pages/Users/User";
import MyAccount from "pages/Users/MyAccount";
import ForgotPassword from "pages/Auth/ForgotPassword";
import ResetPassword from "pages/Auth/ResetPassword";
import Contents from "pages/Content/Contents";
import ContentDetails from "pages/Content/ContentDetails";
import Categories from "pages/Category/Categories";
import Category from 'pages/Category/Category';
import Content from 'pages/Content/Content';
import Configuration from 'pages/Configuration/Configuration';
import Department from 'pages/Department/Department';
import Departments from 'pages/Department/Departments';
import Establishments from 'pages/Establishments/Establishments';
import Establishment from 'pages/Establishments/Establishment';
import Questions from 'pages/Question/Questions';
import Question from 'pages/Question/Question';
import QuestionDetails from 'pages/Question/QuestionDetails';
import Mediators from 'pages/Mediators/Mediators';
import Mediator from 'pages/Mediators/Mediator';
import Students from 'pages/Student/Students';
import Student from 'pages/Student/Student';
import StudentDetails from 'pages/Student/StudentDetails';
import Reasons from 'pages/Reason/Reasons';
import Reason from 'pages/Reason/Reason';
import Agenda from 'pages/Agenda/Agenda';
import Availability from 'pages/Users/Availability';
import MediatorDetails from 'pages/Mediators/MediatorDetails';
import MyAccountEdit from 'pages/Users/MyAccountEdit';
import NoProfile from 'pages/NoProfile';

const adminOnly = ['Admin'];
const mediators = ['Admin', 'Mediator'];

export type RouteType = {
  path: string;
  roles: string[] | 'all';
  Component: React.ComponentType<any>;
  exact?: boolean;
};

const routes: RouteType[] = [
  { path: '/', roles: 'all', Component: Agenda },
  { path: '/dashboard', roles: 'all', Component: Home }, // not used, kept for legacy and debug
  { path: '/planning', roles: mediators, Component: Agenda },
  { path: '/availability', roles: mediators, Component: Availability },
  // Articles
  { path: '/contents', roles: mediators, Component: Contents },
  { path: '/contents/add', roles: mediators, Component: Content },
  { path: '/contents/:id', roles: mediators, Component: ContentDetails },
  { path: '/contents/edit/:id', roles: mediators, Component: Content },
  // Catégories d'articles
  { path: '/categories', roles: adminOnly, Component: Categories },
  { path: '/categories/add', roles: adminOnly, Component: Category },
  { path: '/categories/edit/:id', roles: adminOnly, Component: Category },
  // FAQ
  { path: '/questions', roles: mediators, Component: Questions },
  { path: '/questions/add', roles: mediators, Component: Question },
  { path: '/questions/:id', roles: mediators, Component: QuestionDetails },
  { path: '/questions/edit/:id', roles: mediators, Component: Question },
  // Apprentis
  { path: '/students', roles: mediators, Component: Students },
  { path: '/students/add', roles: mediators, Component: Student },
  { path: '/students/edit/:id', roles: mediators, Component: Student },
  { path: '/students/:id', roles: mediators, Component: StudentDetails },
  // Médiateurs
  { path: '/mediators', roles: adminOnly, Component: Mediators },
  { path: '/mediators/add', roles: mediators, Component: Mediator },
  { path: '/mediators/edit/:id', roles: mediators, Component: Mediator },
  { path: '/mediators/:id', roles: adminOnly, Component: MediatorDetails },
  // Tous les comptes
  { path: '/users', roles: adminOnly, Component: Users },
  { path: '/users/add', roles: adminOnly, Component: User },
  { path: '/users/edit/:id', roles: adminOnly, Component: User },
  // Motifs
  { path: '/reasons', roles: adminOnly, Component: Reasons },
  { path: '/reasons/add', roles: adminOnly, Component: Reason },
  { path: '/reasons/edit/:id', roles: adminOnly, Component: Reason },
  // Etablissements
  { path: '/establishments', roles: adminOnly, Component: Establishments },
  { path: '/establishments/add', roles: adminOnly, Component: Establishment },
  { path: '/establishments/edit/:id', roles: adminOnly, Component: Establishment },
  // Departements
  { path: '/departments', roles: adminOnly, Component: Departments },
  { path: '/departments/add', roles: adminOnly, Component: Department },
  { path: '/departments/edit/:id', roles: adminOnly, Component: Department },
  // Configuration
  { path: '/configuration', roles: adminOnly, Component: Configuration },
  // Mon compte
  { path: '/my-account', roles: mediators, Component: MyAccount },
  { path: '/my-account-edit', roles: mediators, Component: MyAccountEdit },

  // ...fallback
  { path: '*', roles: 'all', exact: false, Component: Page404 },
];

export const noProfileRoutes: RouteType[] = [
  { path: '/no-profile', roles: 'all', Component: NoProfile },
  { path: '/my-account-edit', roles: mediators, Component: MyAccountEdit },
  { path: '/mediators/add', roles: mediators, Component: Mediator },
  { path: '/mediators/edit/:id', roles: mediators, Component: Mediator },

  // ...fallback
  { path: '*', roles: 'all', Component: NoProfile },
];

export const loginRoutes: RouteType[] = [
  { path: '/login', roles: 'all', Component: Login },
  { path: '/forgot-password', roles: 'all', Component: ForgotPassword },
  { path: '/reset-password', roles: 'all', Component: ResetPassword },
  { path: '*', roles: 'all', Component: Login },
];

export default routes;
